import React, { Suspense, lazy, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getIsLoggedIn } from '../publicSession/selectors';
import ErrorBoundary from '../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import retry from '../utils/webpack/chunkRetry';
const LoadableInit = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "chat" */ './ChatInitLoadable')));
const LoadableChatBar = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "chat" */ './ChatBar')));
/**
 * ChatInit checks if chat is enabled for this context and then starts
 * up the connection to wix chat. The chat chunk contains the wix SDK and
 * the redux reducers/sagas. UI is in separate chunks and uses redux actions
 * to perform all SDK actions.
 */ export const ChatInit = ({ disableFloatingChat  })=>{
    const isChatDisabled = useFlag('adbrain');
    const isLoggedIn = useSelector(getIsLoggedIn);
    const isMounted = useIsMounted();
    const isMobile = useContext(MobileContext);
    if (!isLoggedIn || !isMounted || isChatDisabled) {
        return null;
    }
    // prevent chat inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ChatInit"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(LoadableInit, null), !isMobile && !disableFloatingChat && /*#__PURE__*/ React.createElement(LoadableChatBar, null)));
};
ChatInit.displayName = 'ChatInit';
export default ChatInit;
